module.exports = __webpack_public_path__ + "static/media/ProgramOperations.b6a8c0b2.svg";